import { totalWithdrawal } from '@assets/icons'
import Table from '@components/table'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { CircleCheck, CircleX, Eye } from 'lucide-react'
import theme from '@utils/theme'
import { Transaction } from '@apis'
import UserProfile from '@components/userprofile'
import { Helper } from '@utils'
import { useModal } from '@context/ModalContext'
import WithdrawRequestModal from '@commons/withdraw-request-modal'

const Withdrawal = ({ status }: { status?: string }) => {
  const {
    items: Withdraw,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.transaction)
  const [page, setPage] = useState<number>(1)
  const { showModal } = useModal()
  const fetchWithdraw = async () => {
    await Transaction.withdraw({
      state: 'transaction',
      params: { status, page, limit: 20 },
    })
  }

  const columns = [
    {
      title: 'S.N',
      key: 'sn',
      render: (_, i) => i,
    },
    {
      title: 'Provider Details',
      key: 'providerDetails',
      render: (item) => <UserProfile item={item.user} />,
    },
    {
      title: 'Withdraw Amount',
      key: 'withdrawAmount',
      render: (item) => <>Rs {item.amount}</>,
    },
    ...(status === 'Approved' || status === 'Rejected'
      ? [
          {
            title: `Amount ${status === 'Approved' ? 'Released' : status}`,
            key: 'releasedDate',
            render: (item) => (
              <div>
                <p>{item.amount}</p>
              </div>
            ),
          },
        ]
      : []),
    {
      title: 'Request Date',
      key: 'releasedDate',
      render: (item) => (
        <>
          <p>{Helper.formatDate(item.createdAt)}</p>
          <p>{Helper.formatTime(item.createdAt)}</p>
        </>
      ),
    },
  ]
  if (status === 'Rejected' || status === 'Approved') {
    columns.push(
      {
        title: status + ' ' + 'Date',
        key: 'releasedDate',
        render: () => {
          const now = new Date()
          const formattedDate = now.toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
          })
          const formattedTime = now.toLocaleTimeString()
          return (
            <div>
              <p>{formattedDate}</p>
              <p>{formattedTime}</p>
            </div>
          )
        },
      },

      {
        title: 'Status',
        key: 'status',
        render: () => (
          <p
            style={{
              color: status === 'Rejected' ? theme.colors.red : '#4caf4f',
              fontWeight: 600,
            }}
          >
            {status}
          </p>
        ),
      },
    )
  }
  useEffect(() => {
    fetchWithdraw().then(() => {})
  }, [status])
  return (
    <Table
      text="Withdrawal Request"
      icon={totalWithdrawal}
      data={Withdraw}
      columns={columns}
      loading={loading}
      totalItems={totalItems}
      totalPages={totalPages}
      itemsPerPage={20}
      onPageChange={setPage}
      pageControlled={page}
      actions={
        status === 'Rejected' || status === 'Approved'
          ? []
          : [
              {
                key: 'view',
                icon: <Eye color={theme.colors.primary} />,
                onClick: (item) => {
                  showModal(
                    <WithdrawRequestModal item={item} variant={'both'} />,
                  )
                },
              },
              {
                key: 'accept',
                icon: <CircleCheck color={'#4caf4f'} />,
                onClick: (item) => {
                  showModal(
                    <WithdrawRequestModal item={item} variant={'accept'} />,
                  )
                },
              },
              {
                key: 'reject',
                icon: <CircleX color={'#e72929'} />,
                onClick: (item) => {
                  showModal(
                    <WithdrawRequestModal item={item} variant={'reject'} />,
                  )
                },
              },
            ]
      }
    />
  )
}

export default Withdrawal
